module.exports = __webpack_public_path__ + "static/media/character_3.4884de9d.png";